import React from 'react';
import ReactDOM from 'react-dom';
import { Query } from '@apollo/client/react/components';
import Styled from 'styled';
import { FormattedMessage } from 'react-intl';
import { mapAfter } from 'apollo-relay/update-query';

import Modal from 'four-nets/ui-v2/modal/modal';
import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';
import FetchMore from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';

import LikersList from 'four-nets/photoblog/posts/common/likers-list/likers-list';
import query, { PostLikersQuery, PostLikersQueryVariables } from '../post-likers-loader.graphql';

export interface Props {
    id: string;
    open: boolean;
    onClose: () => any;
}

interface State {
    loading?: boolean;
    render?: boolean;
}

class PostLikersDialog extends React.PureComponent<Props, State> {
    state = { loading: false };

    render() {
        const { id, open, onClose } = this.props;

        return (
            <Modal title={<FormattedMessage id='LIKE' />} open={open} onClose={onClose}>
                <Query<PostLikersQuery, PostLikersQueryVariables>
                    query={query}
                    variables={{ postId: id }}
                    fetchPolicy='cache-first'
                >
                    {({ data, loading, fetchMore }) => {
                        return (
                            <LoadingWrapperView loading={loading}>
                                {data && data.post && data.post.likers ? <LikersList {...data.post} /> : null}
                                {data && data.post && data.post.likers && data.post.likers.pageInfo.hasNextPage ? (
                                    <FetchMore
                                        disabled={this.state.loading}
                                        loading={this.state.loading}
                                        onClick={() => {
                                            this.setState({ loading: true });
                                            const endCursor =
                                                data &&
                                                data.post &&
                                                data.post.likers &&
                                                data.post.likers.pageInfo.endCursor;

                                            fetchMore({
                                                variables: { endCursor },
                                                updateQuery: (
                                                    previousResult = {} as PostLikersQuery,
                                                    { fetchMoreResult = {} as PostLikersQuery }
                                                ) => {
                                                    return {
                                                        ...previousResult,
                                                        ...fetchMoreResult,
                                                        post: {
                                                            ...(previousResult && previousResult.post),
                                                            ...(fetchMoreResult && previousResult.post),
                                                            likers: mapAfter(
                                                                previousResult.post && previousResult.post.likers,
                                                                fetchMoreResult.post && fetchMoreResult.post.likers
                                                            ),
                                                        },
                                                    } as PostLikersQuery;
                                                },
                                            }).then(() => {
                                                this.setState({ loading: false });
                                            });
                                        }}
                                    />
                                ) : null}
                            </LoadingWrapperView>
                        );
                    }}
                </Query>
            </Modal>
        );
    }
}

export default Styled({})(PostLikersDialog);
